<template>
    <div>
        <div class="d-flex align-items-center text-align justify-content-center" 
            style="height: 300px; flex-direction: column"
            v-if="loadingInitial">
            <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            <br>
            <p class="mt-2">Loading</p>
        </div>

        <form @submit.prevent="submitForm()" v-else>
            <div class="form-group">
                <label for="example-text-input" class="col-form-label text-left d-block">Pilih Form
                    Customer</label>
                <select class="form-control select-2-form" id="select-2-form" :disabled="loading"
                    v-model="settings.customer_form_id" v-select2>
                    <option value="" selected>--- Pilih Form ----</option>
                    <option :value="item.id" :data-name="item.name" v-for="item in dataFormEngine" :key="item.id"
                        :selected="item.id == settings.customer_form_id">
                        {{item.name}}</option>
                </select>
            </div>

            <div class="form-group">
                <label for="example-text-input" class="col-form-label text-left d-block">Pilih Kategori Kategori Retribusi</label>
                <select class="form-control select-2-form" id="select-2-form-obj" :disabled="loading"
                    v-model="settings.category_service_master_data_id" v-select2>
                    <option value="" selected>--- Pilih Form ----</option>
                    <option :value="item.id" :data-name="item.name" v-for="item in dataMasterData" :key="item.id"
                        :selected="item.id == settings.category_service_master_data_id">
                        {{item.name}}</option>
                </select>
            </div>

            <div class="form-group">
                <!-- {{dataMasterPrefix}} -->
                <label for="example-text-input" class="col-form-label text-left d-block">Pilih Prefix Customer</label>
                <select class="form-control select-2-form" id="select-2-form-prefix" :disabled="loading"
                    v-model="settings.area_master_data_id" v-select2>
                    <option value="" selected>--- Pilih Form ----</option>
                    <option :value="item.id" :data-name="item.name" v-for="item in dataMasterPrefix" :key="item.id"
                        :selected="item.id == settings.area_master_data_id">
                        {{item.name}}</option>
                </select>
            </div>

            <div class="form-group">
                <label for="example-text-input" class="col-form-label text-left d-block">Prefix Customer
                    Code</label>
                <input type="text" class="form-control" v-model="settings.prefix_customer_code" placeholder="eg. CUST/001/">
            </div>

            <div class="form-group">
                <label for="example-text-input" class="col-form-label text-left d-block">Prefix No Rekening</label>
                <input type="text" class="form-control" v-model="settings.account_number" placeholder="eg. 089200">
            </div>

            <div class="form-group">
                <label for="example-text-input" class="col-form-label text-left d-block">Range Prefix Customer</label>
                <input type="text" class="form-control" v-model="settings.range_number" placeholder="eg. 5">
            </div>

            <div class="form-check form-group">
                <div class="custom-control custom-switch switch-primary" style="padding-left: 15px">
                    <input type="checkbox" class="custom-control-input" id="customSwitchPrimary" v-model="settings.is_custom_invoice_code">
                    <label class="custom-control-label" for="customSwitchPrimary">Menggunakan Custom Template Invoice</label>
                </div>
            </div>

            <div class="form-group mb-0" v-if="settings.is_custom_invoice_code">
                <label for="example-text-input" class="col-form-label text-left d-block">Template Kode Invoice</label>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" v-model="settings.custom_invoice_code" placeholder="Masukkan Template Kode Invoice">
                    <div class="input-group-prepend" data-toggle="modal" data-target="#modalHelper">
                        <span class="input-group-text" id="basic-addon1"><b>?</b></span>
                    </div>
                    <!-- <input type="text" class="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1"> -->
                </div>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="modalHelper" tabindex="-1" role="dialog" aria-labelledby="modalHelper" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Cara Penggunaan</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="container-fluid">
                                <b v-html="'{{seq_no}}'"></b> digunakan untuk sequence number, <br>
                                <b v-html="'{{month}}'"></b> digunakan untuk bulan saat ini,<br>
                                <b v-html="'{{month_romawi}}'"></b> digunakan bulan saat ini dengan format romawi, <br>
                                <b v-html="'{{year}}'"></b> digunakan untuk tahun saat ini,<br>
                                <b v-html="'{{customer_code}}'"></b> digunakan untuk kode kustomer<br>
                                <b v-html="'{{company_code}}'"></b> digunakan untuk kode instansi <br>
                                <b v-html="'{{account_number}}'"></b> digunakan untuk prefix no rekening<br><br>
                                <b v-html="'Contoh Penggunaan: '"></b> <span style="font-size:12px" v-html="'TRX/{{seq_no}}/{{month}}/{{month_romawi}}/{{year}}/{{customer_code}}/{{company_code}}'"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button class="btn btn-success waves-effect waves-light mt-4" :disabled="loading">
                Simpan Pengaturan
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            loadingInitial: true,
            dataFormEngine: [],
            dataMasterData: [],
            dataMasterPrefix: [],
            loadFirstTime: 0,

            settings: {
                customer_form_id: '',
                category_service_master_data_id: '',
                prefix_customer_code: '',
                area_master_data_id: '',
                cron_time: '',
                range_number: '',
                is_custom_invoice_code: '',
                custom_invoice_code: '',
                account_number: ''
            }
        }
    },
    computed: {
        customerForm(){
            return this.settings.customer_form_id
        }
    },
    methods: {
        loadInitialData() {
            this.loadingInitial = true;

            // GET COMPANY SETTING
            const companySetting = this.$http.get(`${this.API_URL}company-setting`, {
                headers: { 
                    'Authorization': `Bearer ${this.$cookies.get("token_instance")}`
                }
            })
            
            // GET FORM TEMPLATE
            const formTemplate = this.$http.get(`${this.API_URL}form-template?type=customer`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })

            // GET MASTER DATA
            const masterData = this.$http.get(`${this.API_URL}master-data`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })

            // GET MASTER PREFIX
            const masterPrefix = this.$http.get(`${this.API_URL}master-data?is_prefix=true`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })

            Promise.all([ companySetting, formTemplate, masterData, masterPrefix ])
            .then(([responseCompany, responseForm, responseMasterData, responseMasterPrefix]) => {
                const resultCompany = responseCompany.data;
                const resultForm = responseForm.data;
                const resultMasterData = responseMasterData.data
                const resultMasterPrefix = responseMasterPrefix.data

                if (resultCompany.success && resultForm.success) {
                    this.dataFormEngine = resultForm.data
                    this.dataMasterData = resultMasterData.data
                    this.dataMasterPrefix = resultMasterPrefix.data
                    if(resultCompany.data){ 
                        this.settings.customer_form_id = resultCompany.data.customer_form_id ? resultCompany.data.customer_form_id : ''
                        this.settings.prefix_customer_code = resultCompany.data.prefix_customer_code
                        this.settings.category_service_master_data_id = resultCompany.data.category_service_master_data_id
                        this.settings.area_master_data_id = resultCompany.data.area_master_data_id
                        this.settings.range_number = resultCompany.data.range_number
                        this.settings.cron_time = this.$store.state.userData.company.cron_time
                        this.settings.is_custom_invoice_code = resultCompany.data.is_custom_invoice_code
                        this.settings.custom_invoice_code = resultCompany.data.is_custom_invoice_code ? resultCompany.data.custom_invoice_code : null
                        this.settings.account_number = resultCompany.data.account_number ? resultCompany.data.account_number : null
                     }
                    this.loadingInitial = false;
                    setTimeout(() => {
                        $('.select-2-form').select2();
                        $('.select-2-form-obj').select2();
                        $('.select-2-form-prefix').select2();
                    }, 100);
                }else{
                    this.sAlert('error', resultForm.message)
                }
            })
            .catch(error => {
                console.log(error);
                this.loadingInitial = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        },
        submitForm() {
            this.loading = true

            let storedData = {
                prefix_customer_code: this.settings.prefix_customer_code,
                customer_form_id: this.settings.customer_form_id ? this.settings.customer_form_id : null,
                category_service_master_data_id: this.settings.category_service_master_data_id ? this.settings.category_service_master_data_id : null,
                area_master_data_id: this.settings.area_master_data_id ? this.settings.area_master_data_id : null,
                range_number: this.settings.range_number ? parseInt(this.settings.range_number) : null,
                is_custom_invoice_code: this.settings.is_custom_invoice_code ? 1 : 0,
                custom_invoice_code: this.settings.is_custom_invoice_code ? this.settings.custom_invoice_code : null,
                account_number: this.settings.account_number ? this.settings.account_number : null
                // cron_time: this.settings.cron_time ? this.settings.cron_time : '00:00'
            }
            
            this.$http.put(`${this.API_URL}company-setting`, storedData, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })
            .then(response => {
                const result = response.data;
                
                if(result.success) {
                    this.sAlert('success', "Berhasil membuat template form baru!")
                    this.loadInitialData()
                }else {
                    this.sAlert('error', result.message)
                }
                this.loading = false;
            })
            .catch(error => {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });
        }
    },
    watch: {
        async customerForm() {
            this.loading = true;
            if(this.loadFirstTime > 0){
                await this.$http.put(`${this.API_URL}company-setting`, {
                    customer_form_id: this.settings.customer_form_id ? this.settings.customer_form_id : null,
                    area_master_data_id: null,
                }, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                await this.loadInitialData()
            }
            this.loading = false;
            this.loadFirstTime++
        }
    },
    mounted() {
        this.loadInitialData()
    }
}
</script>

<style>

</style>